import { Col, Select } from 'antd';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateAdvancedReportFormValues } from '../../../../components/Forms/CreateAdvancedReportForm';
import { CreateAutomationFormValues } from '../../../../components/Forms/CreateAutomationForm';
import { CreateFilterFormValues } from '../../../../components/Forms/CreateFilterForm';
import { EditFilterFormValues } from '../../../../components/Forms/EditFilterForm';
import { TicketSystemFieldsKey } from '../../../../model/types';
import useConditionOptions from '../../../../utils/useConditionOptions';
import { getFilterConditionFormFieldName, getFilterFieldConditionByFieldKey } from './FilterAllConditions';

const FilterConditionFieldKeySelect = ({
    index,
    sectionType,
    isPredefinedFilter,
    update,
    isCreateMode,
    conditions = [],
    conditionType
}) => {
    const { t } = useTranslation('admin');

    const { localizeFieldOptions } = useConditionOptions();

    const fieldKeyOptions = conditions
        .filter((condition) => !(isCreateMode && condition.key === TicketSystemFieldsKey.assignee))
        .map((condition) => ({
            label: condition.name,
            value: condition.key,
            disabled: true
        }));

    return (
        <Col span={7}>
            <Controller<
                | CreateFilterFormValues
                | EditFilterFormValues
                | CreateAutomationFormValues
                | CreateAdvancedReportFormValues,
                | `allConditions.${number}.fieldKey`
                | `filter.allConditions.${number}.fieldKey`
                | `anyConditions.${number}.fieldKey`
                | `filter.anyConditions.${number}.fieldKey`
                | `userAllConditions.${number}.fieldKey`
                | `filter.userAllConditions.${number}.fieldKey`
                | `userAnyConditions.${number}.fieldKey`
                | `filter.userAnyConditions.${number}.fieldKey`
            >
                name={`${getFilterConditionFormFieldName(sectionType, conditionType)}.${index}.fieldKey`}
                render={({ field }) => {
                    return (
                        <Select
                            disabled={isPredefinedFilter}
                            optionFilterProp="label"
                            showSearch
                            className="full-width"
                            options={localizeFieldOptions(fieldKeyOptions).map((option) => ({
                                label:
                                    option.value === TicketSystemFieldsKey.assignee
                                        ? option.label + t('deprecated')
                                        : option.label,
                                value: option.value,
                                disabled: option.value === TicketSystemFieldsKey.assignee
                            }))}
                            placeholder={t('Filters.conditionsPlaceholder')}
                            {...field}
                            onChange={(value) => {
                                update(index, {
                                    fieldKey: value,
                                    operator:
                                        getFilterFieldConditionByFieldKey(conditions, value)?.operators?.[0] || null,
                                    value: null,
                                    type: getFilterFieldConditionByFieldKey(conditions, value)?.type || null
                                });
                            }}
                            filterOption={(input, option) => {
                                return option.label.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0;
                            }} //for case-sensitive searches
                        />
                    );
                }}
            />
        </Col>
    );
};

export default FilterConditionFieldKeySelect;
